import React, { Component } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'

import LinearProgress from '@material-ui/core/LinearProgress'
import Chip from '@material-ui/core/Chip'
import RefreshIcon from '@material-ui/icons/Refresh'
import CheckIcon from '@material-ui/icons/Check'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'

import MaterialTable from 'material-table'

import TimeAgo from 'react-timeago'
import { saveAs } from 'file-saver'
import XlsxPopulate from 'xlsx-populate'
import {
  getBestTeachingData,
  getBestTeachingStats,
  updateBestTeachingData
} from '../../services/saga'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  },

  chip: {
    margin: theme.spacing(0.5)
  }
}))

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />
}

let campusname

const headCellsByCampusCore = [
  {
    field: 'coreChoiceCourseName',
    numeric: false,
    disablePadding: false,
    title: 'Course Name'
  },
  {
    field: 'coreChoiceProfessor',
    numeric: false,
    disablePadding: false,
    title: 'Faculty'
  },
  {
    field: 'coreChoiceCampus',
    numeric: false,
    disablePadding: false,
    title: 'Campus'
  },
  {
    field: 'coreChoiceTotalEnrolled',
    numeric: false,
    disablePadding: false,
    title: 'Npax (Excel)'
  },
  {
    field: 'votes',
    numeric: true,
    disablePadding: false,
    title: 'Nvotes'
  },
  {
    field: 'pvotes',
    numeric: true,
    disablePadding: false,
    title: '% of Votes'
  }
]

const headCellsByCampusElective = [
  {
    field: 'electiveChoiceCourseName',
    numeric: false,
    disablePadding: false,
    title: 'Course Name'
  },
  {
    field: 'electiveChoiceProfessor',
    numeric: false,
    disablePadding: false,
    title: 'Faculty'
  },
  {
    field: 'electiveChoiceCampus',
    numeric: false,
    disablePadding: false,
    title: 'Campus'
  },
  {
    field: 'electiveChoiceTotalEnrolled',
    numeric: false,
    disablePadding: false,
    title: 'Npax (Excel)'
  },
  {
    field: 'votes',
    numeric: true,
    disablePadding: false,
    title: 'Nvotes'
  },
  {
    field: 'pvotes',
    numeric: true,
    disablePadding: false,
    title: '% of Votes'
  }
]

const headCellsByProfCore = [
  {
    field: 'coreChoiceProfessor',
    numeric: false,
    disablePadding: false,
    title: 'Faculty'
  },
  {
    field: 'coreChoiceCourseName',
    numeric: false,
    disablePadding: false,
    title: 'Course Name'
  },
  {
    field: 'coreChoiceCampus',
    numeric: false,
    disablePadding: false,
    title: 'Campus'
  },
  {
    field: 'studentvotes',
    numeric: true,
    disablePadding: false,
    title: 'Nvotes'
  },
  {
    field: 'pvotes',
    numeric: true,
    disablePadding: false,
    title: '% of Votes'
  }
]
const headCellsByProfElective = [
  {
    field: 'electiveChoiceProfessor',
    numeric: false,
    disablePadding: false,
    title: 'Faculty'
  },
  {
    field: 'electiveChoiceCourseName',
    numeric: false,
    disablePadding: false,
    title: 'Course Name'
  },
  {
    field: 'electiveChoiceCampus',
    numeric: false,
    disablePadding: false,
    title: 'Campus'
  },
  {
    field: 'studentvotes',
    numeric: true,
    disablePadding: false,
    title: 'Nvotes'
  },
  {
    field: 'pvotes',
    numeric: true,
    disablePadding: false,
    title: '% of Votes'
  }
]

class SurveyResult extends Component {
  constructor() {
    super()
    this.state = {
      loadingCourse: true,
      loadingMessage: 'Survey results are loading.. please wait.',
      selectedCourses: [],
      courseType: '',
      campus: '',
      responsecount: 0,
      lastupdated: '',
      reportTitle: '',
      error: '',
      setOpen: false
    }
  }

  async componentDidMount() {
    try {
      this.setState({
        courseType:
          this.props.data.courseType == 'core'
            ? 'Core Course '
            : 'Elective Course '
      })
      const courseData = await getBestTeachingData(
        this.props.data.courseType,
        this.props.data.campus
      )
      const stats = await getBestTeachingStats()
      if(stats.length > 0) {
        this.setState({
          responsecount: `Responses: ${stats.data[0].responsecount}`
        })
        this.setState({ lastupdated: stats.data[0].createdAt })
      }
      this.setState({ loadingCourse: false })
      this.setState({ selectedCourses: courseData.data })
      switch (this.props.data.campus) {
        case 'S':
          campusname = 'Singapore Campus'
          break
        case 'SGP':
          campusname = 'Singapore Campus'
          break
        case 'F':
          campusname = 'Fonteinbleu Campus'
          break
        case 'FBL':
          campusname = 'Fonteinbleu Campus'
          break
        case 'A':
          campusname = 'Abu Dhabi'
          break
        case 'B':
          campusname = 'BTH Campus'
          break
        default:
          campusname = 'Invalid Campus'
      }
      this.setState({ campus: campusname })
      this.setState({
        reportTitle: `${this.state.campus} - ${this.state.courseType}`
      })
    } catch (e) {
      this.setState({ loadingCourse: false, error: 'Error Fetching Data' })
    }
  }

  getSheetData = (data, header) => {
    const fields = Object.keys(data[0])
    const sheetData = data.map((row) =>
      fields.map((fieldName) => (row[fieldName] ? row[fieldName] : ''))
    )
    sheetData.unshift(header)
    return sheetData
  }

  downloadReport = async (data, header, filename) => {
    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const sheet1 = workbook.sheet(0)
      const sheetData = this.getSheetData(data, header)
      const totalColumns = sheetData[0].length

      sheet1.cell('A1').value(sheetData)
      const range = sheet1.usedRange()
      const endColumn = String.fromCharCode(64 + totalColumns)
      sheet1.row(1).style('bold', true)
      sheet1.range(`A1:${endColumn}1`).style('fill', 'BFBFBF')
      range.style('border', true)
      return workbook.outputAsync().then((res) => {
        saveAs(res, `${filename}.xlsx`)
      })
    })
  }

  render() {
    const { data } = this.props
    const handleRefresh = async (event) => {
      this.setState({ loadingMessage: 'Refreshing Data from Qualtrics' })
      this.setState({ loadingCourse: true })
      const stats = await updateBestTeachingData()
      if (stats.status == 'success') {
        this.setState({
          loadingMessage: 'Survey results are loading.. please wait.'
        })
        const courseData = await getBestTeachingData(
          this.props.data.courseType,
          this.props.data.campus
        )
        const stats = await getBestTeachingStats()
        if(stats.data.length > 0) {
          this.setState({
            responsecount: `Responses: ${stats.data[0].responsecount}`
          })
          this.setState({ lastupdated: stats.data[0].createdAt })
        }
        this.setState({ selectedCourses: courseData.data })
        this.setState({ loadingCourse: false })
      }
    }
    const handleUptodate = async (event) => {
      this.setState({ setOpen: true })
    }
    const handleCloseAlert = async (event) => {
      this.setState({ setOpen: false })
    }

    return (
      <>
        {this.state.loadingCourse === true ? (
          <div>
            <p>{this.state.loadingMessage}</p>
            <LinearProgress /> <br />
          </div>
        ) : (
          <Card variant='outlined'>
            <CardContent>
              <Typography variant='h5' component='h2'>
                {this.state.responsecount}
              </Typography>
              <Typography variant='body2' component='p'>
                <TimeAgo date={this.state.lastupdated} />
              </Typography>
            </CardContent>
            <CardActions>
              {new Date(this.state.lastupdated) > Date.now() - 3600000 ? (
                <Chip
                  variant='outlined'
                  label='Up to date'
                  color='primary'
                  onDelete={handleUptodate}
                  deleteIcon={<CheckIcon />}
                />
              ) : (
                <Chip
                  variant='outlined'
                  label='Refresh'
                  color='primary'
                  onDelete={handleRefresh}
                  deleteIcon={<RefreshIcon />}
                />
              )}
            </CardActions>
          </Card>
        )}
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={this.state.setOpen}
        >
          <Alert severity='info' onClose={handleCloseAlert}>
            Data up to date, Please refresh after an hour
          </Alert>
        </Snackbar>
        <p />
        <p />

        {this.props.data.campus == 'Prof' ? (
          <MaterialTable
            title={`${this.state.courseType} - By Prof`}
            columns={
              this.props.data.courseType == 'core'
                ? headCellsByProfCore
                : headCellsByProfElective
            }
            data={this.state.selectedCourses}
            actions={[
              {
                icon: 'file_download',
                tooltip: 'Download as Excel',
                position: 'toolbar',
                onClick: () => {
                  const columns =
                    this.props.data.courseType == 'core'
                      ? headCellsByProfCore
                      : headCellsByProfElective
                  const header = columns.map((x) => x.title)
                  this.downloadReport(
                    this.state.selectedCourses,
                    header,
                    `${this.state.courseType} - By Prof`
                  )
                }
              }
            ]}
            options={{
              search: false,
              // selection: true,
              // pageSize: 25,
              // emptyRowsWhenPaging: false,
              // pageSizeOptions: PAGE_OPTIONS.split(',')
              filtering: true,
              exportAllData: true,
              pageSize: 10,
              pageSizeOptions: [10, 20, 30]
            }}
            // localization={{
            //   body: {
            //     emptyDataSourceMessage: 'Please select programme and correct term.'
            //   }

            // }}
            // onSelectionChange={handleClick}
          />
        ) : (
          <MaterialTable
            title={this.state.reportTitle}
            columns={
              this.props.data.courseType == 'core'
                ? headCellsByCampusCore
                : headCellsByCampusElective
            }
            data={this.state.selectedCourses}
            actions={[
              {
                icon: 'file_download',
                tooltip: 'Download as Excel',
                position: 'toolbar',
                onClick: () => {
                  const columns =
                    this.props.data.courseType == 'core'
                      ? headCellsByCampusCore
                      : headCellsByCampusElective
                  const header = columns.map((x) => x.title)
                  this.downloadReport(
                    this.state.selectedCourses,
                    header,
                    this.state.reportTitle
                  )
                }
              }
            ]}
            options={{
              search: true,
              exportAllData: true,
              pageSize: 10,
              pageSizeOptions: [10, 20, 30]
              // selection: true,
              // pageSize: 25,
              // emptyRowsWhenPaging: false,
              // pageSizeOptions: PAGE_OPTIONS.split(',')
              // filtering: true
            }}
          />
        )}

        <p />
        <p />
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  data: state.BestTeachingAwardReport
})

export default connect(mapStateToProps)(SurveyResult)
